// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__4DBBy","notes":"Notes_notes__8worP"};